function initSplideHero() {
	const splideElem = document.querySelector(".mm-hero-splide");
	if (splideElem && !splideElem.classList.contains("is-initialized")) {
		if (splideElem.splideInstance) {
			splideElem.splideInstance.destroy(true);
		}
		const splideInstance = new Splide(splideElem, {
			type: "fade",
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 6000,
			perPage: 1,
		}).mount();
		splideElem.splideInstance = splideInstance;
		splideElem.classList.add("is-initialized");
	}
}

document.addEventListener("DOMContentLoaded", initSplideHero);
